import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import './styles.scss'
import { setActiveChannel, setActiveUser } from 'redux/actions/tabs'
import MessageScheduleBanner from 'components/Chat/MessageScheduleBanner'
import Composer from './Composer'
import ChatMessages from './ChatMessages'
import SideView from './SideView'
import { WarningMessage } from 'components/common'
import { lang } from 'utils/helpers'
import { validateDeactivatedUsers } from './utils'
import UserOptions from './UserOptions'
import inchatActions from 'redux/inchat/actions'

const InChatView = () => {
  const { tabs, inchat, user: operator } = useSelector(store => store)
  const { activeUser: conversationId, activeChannel } = tabs
  const conversationInfo = inchat?.conversations[conversationId]?.conversation || {}
  const { isOpenThreads } = inchat
  const dispatch = useDispatch()
  const { push } = useHistory()
  const composer = inchat.conversations?.[conversationId]?.composer || {}
  const scheduled = inchat.scheduled || {}
  const conversationScheduled = scheduled.data?.filter(({ operator: operatorId, conversation }) => {
    return conversation._id === conversationId && operatorId === operator._id
  })

  useEffect(() => {
    dispatch(inchatActions.seenMessages(conversationId))
  }, [conversationId])

  const goToScheduledMessages = () => {
    push({
      pathname: '/dashboard/conversations/inchat',
      search: '?section=scheduled'
    })
    dispatch(setActiveUser(''))
    dispatch(setActiveChannel(''))
  }

  return (
    <div className='inchat-view'>
      <div className='inchat-view__header'>
        {validateDeactivatedUsers(conversationInfo, operator._id)
          ?<WarningMessage text={lang('dashboard_user-deactivated')} />
          :<>
            {/* BOTONES - JOIN */}
            <UserOptions
              conversationId={conversationId}
              composer={composer}
            />

            {/* COMPOSER */}
            <Composer
              conversationId={conversationId}
              channel={activeChannel}
              composer={composer}
              scheduled={scheduled}
            />
          </>
        }
      </div>
      {conversationScheduled.length ? (
        <MessageScheduleBanner
          count={conversationScheduled.length}
          date={conversationScheduled.length === 1 ? conversationScheduled[0].scheduledAt : ''}
          onClick={goToScheduledMessages}
        />
      ) : null}
      <div className='inchat-view__body'>
        <ChatMessages
          key={`messages-${conversationId}`}
          conversationId={conversationId}
          operatorId={operator.id}
        />
      </div>
      {isOpenThreads ?
        <SideView
          conversationId={conversationId}
          channel={activeChannel}
          operatorId={operator.id}
        />
        : null}
    </div>
  )
}

export default InChatView
